import { Provider } from "react-redux";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { withTranslation } from "react-i18next";
import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";
import RouterConfig from "../routes/routerConfig";
import store from "../redux/store";
import theme from "../styles/js/theme";
// import initializePendo from '../pendo';

export function App() {
  const {
    VITE_RUM_APPLICATION_ID,
    VITE_RUM_CLIENT_TOKEN,
    VITE_RUM_SITE,
    VITE_RUM_SERVICE,
    VITE_RUM_ENV,
    VITE_GA4_TRACKING_ID,
  } = import.meta.env;

  // Initialize analytics and monitoring once
  useEffect(() => {
    ReactGA.initialize(VITE_GA4_TRACKING_ID);

    datadogRum.init({
      applicationId: VITE_RUM_APPLICATION_ID,
      clientToken: VITE_RUM_CLIENT_TOKEN,
      site: VITE_RUM_SITE,
      service: VITE_RUM_SERVICE,
      env: VITE_RUM_ENV,
      // Specify a version number to identify the deployed version of your application in Datadog
      version: "BUILD_DATE_TIME",
      sampleRate: 100,
      trackInteractions: true,
      defaultPrivacyLevel: "mask-user-input",
      trackUserInteractions: true,
      trackFrustrations: true,
      enableExperimentalFeatures: ["clickmap"],
      allowedTracingUrls: [
        {
          match: (url) => {
            const requestUrl = new URL(url, window.location.origin);
            return (
              requestUrl.origin === window.location.origin &&
              /^\/(?:cortex|integration)(?:\/|$)/.test(requestUrl.pathname)
            );
          },
          propagatorTypes: ["datadog", "tracecontext"],
        },
      ],
    });
    datadogLogs.init({
      clientToken: VITE_RUM_CLIENT_TOKEN,
      site: VITE_RUM_SITE,
      forwardErrorsToLogs: true,
      sampleRate: 100,
    });
    datadogRum.startSessionReplayRecording();
  }, []);
  // const { user } = store.getState()?.authentication;
  // const { cartDetails } = store.getState();
  // const { oktaUserID } = cartDetails;
  // useEffect(() => {
  //   if (Object.keys(user).length > 0) {
  //     initializePendo({ userID: oktaUserID, accountID: user?.accountID, email: user?.email });
  //   }
  // }, [user]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <RouterConfig />
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default withTranslation()(App);
